import { ChannelEntity } from '../ChannelEntity';
import { createEntityNodeView } from './createEntityNodeView';

export const ChannelNodeView = createEntityNodeView('channel', ChannelEntity);
